import React from 'react';

/**
 * Convert newlines to <br /> tags (similar to PHP's nl2br function)
 * @param text - The text to convert
 * @returns JSX element with <br /> tags for newlines
 */
export const nl2br = (text: string | null | undefined): React.ReactNode => {
  if (!text) return null;
  
  return text.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < text.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));
};

/**
 * Convert newlines to <br /> tags and preserve whitespace (similar to nl2br with pre-wrap)
 * @param text - The text to convert
 * @returns JSX element with <br /> tags and preserved whitespace
 */
export const nl2brPreserve = (text: string | null | undefined): React.ReactNode => {
  if (!text) return null;
  
  return (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      {text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < text.split('\n').length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
};

/**
 * Safe nl2br function that handles null/undefined and empty strings
 * @param text - The text to convert
 * @param fallback - Fallback text if input is empty
 * @returns JSX element with <br /> tags or fallback
 */
export const safeNl2br = (text: string | null | undefined, fallback: React.ReactNode = null): React.ReactNode => {
  if (!text || text.trim() === '') return fallback;
  return nl2br(text);
};
